<template>
    <div class="thermometer-type-1" :class="[leadscoreClass]" v-if="leadscore > .5">
        <div></div>
    </div>
</template>

<script>
export default {
    name: "ThermometerMini",
    props: {
        leadscore: {
            type: Number,
            required: true
        }
    },
    computed: {
        leadscoreClass() {
            if (this.leadscore > .9) {
                return 'hot';
            } else if (this.leadscore > .75) {
                return 'warm';
            } else {
                return 'cold';
            }
        }
    }
}
</script>